import { ButtonBase, Menu, MenuItem, Typography } from '@material-ui/core'
import React, { useState } from 'react'

import { getTranslate, lang } from '../../localization'
import {
  MonitoringUpdateRoomTypeFieldsType,
  MonitoringUpdateRoomTypeLayer
} from '../../types/monitoringUpdate'

interface RoomTypeLayerRowMenuProps {
  mayItemMenu: {
    value: MonitoringUpdateRoomTypeFieldsType
    label: string
  }[]
  setSelectedRoomTypeRowMenu: React.Dispatch<
    React.SetStateAction<MonitoringUpdateRoomTypeFieldsType>
  >
  onChangeSelectedItem: (newMenuItem: string) => void
  selectedRoomTypeRowMenu: MonitoringUpdateRoomTypeFieldsType
  dataRoomType: MonitoringUpdateRoomTypeLayer
}

export default function RoomTypeLayerRowMenu({
  mayItemMenu,
  onChangeSelectedItem,
  setSelectedRoomTypeRowMenu,
  selectedRoomTypeRowMenu,
  dataRoomType
}: RoomTypeLayerRowMenuProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  const handleOpenMenu = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setAnchorEl(event.currentTarget)
  }
  const handleCloseMenu = () => {
    setAnchorEl(null)
  }
  const handleChangeMenuItem = (
    selectedItem: MonitoringUpdateRoomTypeFieldsType
  ) => {
    onChangeSelectedItem?.(selectedItem)
    setSelectedRoomTypeRowMenu(selectedItem)
    handleCloseMenu()
  }
  if (
    dataRoomType.dataForEachDate.some((dataItem) => dataItem.pooledAvailability)
  ) {
    mayItemMenu = mayItemMenu.filter(() => true)
  } else {
    mayItemMenu = mayItemMenu.filter(
      (ele) => ele.value !== 'pooledAvailability'
    )
  }
  if (
    dataRoomType.dataForEachDate.some(
      (dataItem) => dataItem.totalAllocatedAvailabiliy
    )
  ) {
    mayItemMenu = mayItemMenu.filter(() => true)
  } else {
    mayItemMenu = mayItemMenu.filter(
      (ele) => ele.value !== 'totalAllocatedAvailabiliy'
    )
  }

  return (
    <div>
      <ButtonBase aria-controls="simple-menu" onClick={handleOpenMenu}>
        <Typography variant="h5">
          {lang === 'en'
            ? getTranslate(selectedRoomTypeRowMenu).slice(0, 3) + '...'
            : selectedRoomTypeRowMenu.length > 12
            ? getTranslate(selectedRoomTypeRowMenu).slice(0, 10) + '...'
            : getTranslate(selectedRoomTypeRowMenu)}
        </Typography>
      </ButtonBase>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}>
        {mayItemMenu.map((mayItem) => {
          return (
            <MenuItem
              key={mayItem.value}
              value={mayItem.value}
              onClick={() => handleChangeMenuItem(mayItem.value)}>
              {getTranslate(mayItem.label)}
            </MenuItem>
          )
        })}
      </Menu>
    </div>
  )
}
